import React, { useEffect, useState } from "react";
import { fetchCourseReviews } from "./api";

const CourseReviewIndex = ({ isPageMode }) => {
  const [reviews, setCourseReviews] = useState([]);
  const [page, setPage] = useState(1);
  const limit = isPageMode ? 10 : 5;
  useEffect(() => {
    const fetchData = async () => {
      const data = await fetchCourseReviews(page, limit);
      console.log("Data:", data);
      setCourseReviews(data?.reviews);
    };
    fetchData();
  }, [page]);

  Date.prototype.addHours = function (h) {
    this.setTime(this.getTime() + h * 60 * 60 * 1000);
    return this;
  };

  return (
    <div className="mt-4">
      <div className="is-flex is-justify-content-space-between">
        <h1 className="title is-5 has-text-center">
          Recent Reviews {isPageMode && `(p. ${page})`}
        </h1>
        {isPageMode && (
          <div>
            {page > 1 && (
              <button
                onClick={() => {
                  setPage((prev) => prev - 1);
                }}
                className="button is-grey-dark">
                {"<"}
              </button>
            )}

            <button
              onClick={() => {
                setPage((prev) => prev + 1);
              }}
              className="button is-grey-dark ml-2">
              {">"}
            </button>
          </div>
        )}
      </div>
      {reviews?.map((review) => (
        <a href={`/reviews/${review._id}`}>
          <div className="card has-background-grey m-3" key={review.id}>
            <div className="card-content">
              <p className="is-flex is-justify-content-space-between">
                <small className="muted-text has-text-white">
                  {new Date(review.created_at)
                    .addHours(1)
                    .toLocaleDateString() +
                    " " +
                    new Date(review.created_at)
                      .addHours(1)
                      .toLocaleTimeString()}{" "}
                  -{" "}
                  <span className="tag is-secondary">
                    {review.is_premium ? "Premium User" : "Free User"}
                  </span>
                </small>
                <div>
                  <p
                    className={
                      review.rating < 3
                        ? "tag muted-text is-danger "
                        : "tag muted-text is-light"
                    }>
                    <strong className="has-text-black">
                      {review.rating} / 5
                    </strong>
                  </p>
                  <p
                    className={
                      !review.status || review.status === "Unhandled"
                        ? "tag muted-text is-danger ml-3"
                        : "tag muted-text is-light ml-3"
                    }>
                    <strong className="has-text-black">
                      {review.status ? review.status : "Unhandled"}
                    </strong>
                  </p>
                </div>
              </p>
              <p className="has-text-black subtitle">{review.content}</p>
            </div>
          </div>
        </a>
      ))}
    </div>
  );
};

export default CourseReviewIndex;
